import yearlyDialogComponent from './yearly-dialog.component';

export default angular
  .module('fizyweb.paycell.yearly', [])
  .component('yearlyDialog', yearlyDialogComponent).name;



// WEBPACK FOOTER //
// src/app/buy/yearly-info/yearly-dialog.module.ts